import React,{useEffect,useState} from "react";


import Header from './Header/Header'
import Footer from './footer/Footer'
import {connect} from 'react-redux'
const PageWrapper = (props) => {
  //alert("page wrappe")
 

  const [offset, setOffset] = useState(0);

  useEffect(() => {
    window.onscroll = () => {
      // setOffset(window.pageYOffset)
      // console.log(window.pageYOffset)
      // if(window.pageYOffset>=300){
      //   document.body.classList.add('headerFixed');
      // }else{
      //   document.body.classList.remove('headerFixed');
      
        
      // }
      if( window.innerWidth>= 992) {
        var scrolltop = 0;
        if(window.pageYOffset > scrolltop) {
          document.body.classList.add('headerFixed');
        } else {
          document.body.classList.remove('headerFixed');
        }
        }
    }
  }, []);
//console.warn(props.children,"{props.children}")
  return (
    <>
          <div className={'maincontainer w-left'}>
            <Header title={props.title} login_name={props.login?props.login.user_fname:''}></Header>
           
            {props.children}
          
            <Footer/>
            </div>
          {/* {} */}

            
       
        
    </>
  );
};
const mapStateToProps=(state)=>{
  return{login:state.list.login}
  }
  
    export default connect(mapStateToProps)((PageWrapper));
//export default PageWrapper;
